import axios from 'axios';
import {constants, notificationSettingsSelected} from '../assets/constants/constants';
import Api from './index';
import {ALM_URL, endPoints} from './urls';

async function checkAlmUser() {
  const response = await Api(true).get(`${ALM_URL}/user`);
  const result = response;
  return result;
}
async function getUploadInfo() {
  try {
    const response = await axios.get(`${ALM_URL}/uploadInfo`, {
      headers: {
        Accept: 'application/vnd.api+json',
        Authorization: 'oauth ' + localStorage.getItem('access_token'),
      },
    });

    return response;
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}
async function uploadImage(body: any) {
  const response = await Api(true).post(`${ALM_URL}/avatar`, {imageUrl: body});
  const result = response;
  return result;
}
async function getLearningProgram(tagName: string) {
  const extraParams = {
    params: {
      include: 'instances,enrollment,subLOs.subLOs,instances.badge',
      'page[limit]': constants?.LP_PAGE_LIMIT,
      sort: 'name',
      'filter.tagName': tagName,
      completed: true,
      'filter.loTypes': 'learningProgram',
      'filter.ignoreEnhancedLP': false,
    },
  };
  const response = await Api(true).get(
    `${ALM_URL}/${endPoints.ALL_LEARNING_PROGRAMS}`,
    extraParams
  );
  const result = response;
  return result;
}
async function getFundamentalProgram(id: string) {
  const response = await Api(true).get(`${ALM_URL}/${endPoints.FNDAMENTAL_PROGRAM}/${id}`);
  const result = response;
  return result;
}

async function getProgramList(id?: string) {
  const parms = [
    ///new valuse
    'enrollment.loInstance.loResources.resources',
    'instances.loResources.resources',
    'supplementaryLOs.instances.loResources.resources',
    'subLOs.instances.loResources.resources',
    'supplementaryResources',
    'subLOs.supplementaryResources',
    'subLOs.supplementaryLOs',
    'enrollment.loResourceGrades',
    'subLOs.enrollment.loResourceGrades',
    //'enrollment.loResourceGrades',
    //'subLOs.enrollment.loResourceGrades',
    // 'enrollment.loInstance.loResources.resources',
    // 'instances.loResources.resources',
    'skills.skillLevel.skill',
    'subLOs.instances.subLoInstances',
    //'subLOs.instances.loResources.resources',
    'subLOs.subLOs',
    //'supplementaryResources',
    'supplementaryLOs',
    'instances.badge',
    'subLOs.subLOs.enrollment',
    'instances.badge',
    //'subLOs.subLOs.enrollment',
    'subLOs.subLOs.instances.loResources.resources', //for mutiple modules re
    'subLOs.subLOs.instances.loResources', //for mutiple modules
    'subLOs.subLOs.enrollment.loResourceGrades',
  ];

  const includeParams = `?include=${parms.toString()}`;
  const response = await Api(true).get(
    `${ALM_URL}/${endPoints.FNDAMENTAL_PROGRAM}/${id}${includeParams}`
  );
  const result = response;
  return result;
}
async function getCourseDetail(id?: string) {
  const parms = [
    ///new valuse
    'enrollment.loInstance.loResources.resources',
    'instances.loResources.resources',
    'supplementaryLOs.instances.loResources.resources',
    'subLOs.instances.loResources.resources',
    'supplementaryResources', //to get main program lesstion
    'subLOs.subLOs.supplementaryResources', // to get lesson resourses
    'subLOs.supplementaryLOs',
    'enrollment.loResourceGrades',
    'subLOs.enrollment.loResourceGrades',
    //'enrollment.loResourceGrades',
    //'subLOs.enrollment.loResourceGrades',
    // 'enrollment.loInstance.loResources.resources',
    // 'instances.loResources.resources',
    'skills.skillLevel.skill',
    'subLOs.instances.subLoInstances',
    //'subLOs.instances.loResources.resources',
    'subLOs.subLOs',
    //'supplementaryResources',
    'supplementaryLOs',
    'instances.badge',
    'subLOs.subLOs.enrollment',
    'instances.badge',
    //'subLOs.subLOs.enrollment',
    'subLOs.subLOs.instances.loResources.resources', //for mutiple modules re
    'subLOs.subLOs.instances.loResources', //for mutiple modules
    'subLOs.subLOs.enrollment.loResourceGrades',
  ];

  const includeParams = `?include=${parms.toString()}`;
  const response = await Api(true).get(
    `${ALM_URL}/${endPoints.FNDAMENTAL_PROGRAM}/${id}${includeParams}`
  );
  const result = response;
  return result;
}
async function getFundamentalProgramList(catelogId:string ) {
  const parms = [
    'enrollment.loResourceGrades',
    'enrollment.loInstance.loResources.resources',
    'subLOs.enrollment.loResourceGrades',
    'subLOs.subLOs',
    'supplementaryResources',
    'supplementaryLOs',
    'enrollment',
    'instances.badge',
    'subLOs.subLOs.enrollment',
    'subLOs.subLOs.instances.loResources',
    'subLOs.subLOs.instances.loResources.resources',
  ];
  const extraParams = {
    params: {
      'page[limit]': constants.LP_PAGE_LIMIT,
      sort: 'name',
      'filter.tagName': 'Fundamental Program',
      'filter.loTypes': 'learningProgram',
      'filter.ignoreEnhancedLP': false,
      'filter.catalogIds':catelogId,
    },
  };
  const includeParams = `?include=${parms.toString()}`;
  const response = await Api(true).get(
    `${ALM_URL}/${endPoints.FNDAMENTAL_PROGRAM}/${includeParams}`,
    extraParams
  );
  const result = response;
  return result;
}

async function getProgramDetailByCourseId(courseId: any) {
  const apiUrl = `${ALM_URL}/${endPoints.ALL_LEARNING_PROGRAMS}/course:${courseId}/relatedLOs?limit=5&type=learningPrograms`;
  const response = await Api(true).get(apiUrl);
  const result = response;
  return result;
}

async function getBadges(badgeId: string) {
  const response = await Api(true).get(`${ALM_URL}/${endPoints.ALM_BADGES}/${badgeId}`);
  const result = response;
  return result;
}

async function getEnrollments(courseId: string) {
  const response = await Api(true).get(`${ALM_URL}/${endPoints.ALM_ENROLLMENTS}/${courseId}`);
  const result = response;
  return result;
}
async function getBookmark(courseId: string) {
  const response = await Api(true).get(
    `${ALM_URL}/${endPoints.FNDAMENTAL_PROGRAM}/${courseId}/${endPoints.ALM_BOOKMARK}`
  );
  const result = response;
  return result;
}
async function userEnroll(cid?: string, loInstanceId?: string) {
  const response = await Api(true).post(
    `${ALM_URL}/${endPoints.ALM_ENROLLMENTS}/?loId=${cid}&loInstanceId=${loInstanceId}`
  );
  const result = response;
  return result;
}
async function getProgramDetail(courseId: any) {
  const response = await Api(true).get(`${ALM_URL}/${endPoints.ALL_LEARNING_PROGRAMS}/${courseId}`);
  const result = response;
  return result;
}
async function getRelatedContent(courseId: any) {
  const apiUrl = `${ALM_URL}/${endPoints.ALL_LEARNING_PROGRAMS}?page[limit]=10&filter.loTypes=course&sort=name&filter.tagName=${courseId}&filter.ignoreEnhancedLP=false&filter.ignoreHigherOrderLOEnrollment=true`;
  const response = await Api(true).get(apiUrl);
  const result = response;
  return result;
}

async function getPost(boardId: any) {
  const extraParams = {
    params: {
      'page[offset]': constants.OFFSET,
      'page[limit]': constants.LP_PAGE_LIMIT,
      sort: 'dateCreated',
    },
  };
  const response = await Api(true).get(
    `${ALM_URL}/${endPoints.ALM_BOARDS}/${boardId}/${endPoints.ALM_POSTS}`,
    extraParams
  );
  const result = response;
  return result;
}

const fetchCatalogs = async () => {
  const extraParams = {
    params: {
      'page[offset]': constants.OFFSET,
      'page[limit]': constants.LP_PAGE_LIMIT,
      sort: 'name',
    },
  };
  const response = await Api(true).get(`${ALM_URL}/${endPoints.CATALOGS}`, extraParams);
  const result = response;
  return result;
};

const fetchContentByCatalogId = async (catId: any, type?: string) => {
  const extraParams = {
    params: {
      'page[limit]': 10,
      'filter.loTypes': type === 'Achievements' ? 'learningProgram' : 'course',
      'filter.catalogIds': catId,
      sort: 'name',
      'filter.ignoreHigherOrderLOEnrollment': true,
      'filter.ignoreEnhancedLP': false,
      include: 'instances.badge',
    },
  };
  const response = await Api(true).get(
    `${ALM_URL}/${endPoints.ALL_LEARNING_PROGRAMS}`,
    extraParams
  );
  const result = response;
  return result;
};
const unEnrollProgram = async (id: any) => {
  const response = await Api(true).delete(`${ALM_URL}/${endPoints.ALM_PROGRAM_UNENROLLMENT}/${id}`);
  const result = response;
  return result;
};

const addBookMarkLearningObjects = async (id: any) => {
  const response = await Api(true).post(
    `${ALM_URL}/${endPoints.ALL_LEARNING_PROGRAMS}/${id}/${endPoints.ALM_BOOKMARK}`
  );
  const result = response;
  return result;
};
const deleteBookMarkLearningObjects = async (id: any) => {
  const response = await Api(true).delete(
    `${ALM_URL}/${endPoints.ALL_LEARNING_PROGRAMS}/${id}/${endPoints.ALM_BOOKMARK}`
  );
  const result = response;
  return result;
};
const fetchNewVideos = async () => {
  const extraParams = {
    params: {
      'page[limit]': 10,
      'filter.loTypes': 'course',
      sort: 'name',
      'filter.tagName': 'New Video',
      'filter.ignoreEnhancedLP': false,
    },
  };
  const response = await Api(true).get(
    `${ALM_URL}/${endPoints.ALL_LEARNING_PROGRAMS}`,
    extraParams
  );
  const result = response;
  return result;
};
const fetchContentByCatalogIdForLibrary = async (catId: any, type?: string) => {
  const extraParams = {
    params: {
      'page[limit]': 100,
      'filter.loTypes': type === 'Achievements' ? 'learningProgram' : 'course',
      'filter.catalogIds': catId,
      sort: 'name',
      'filter.ignoreHigherOrderLOEnrollment': true,
      'filter.ignoreEnhancedLP': false,
    },
  };
  const response = await Api(true).get(
    `${ALM_URL}/${endPoints.ALL_LEARNING_PROGRAMS}`,
    extraParams
  );
  const result = response;
  return result;
};
const getCalender = async (id: any) => {
  const response = await Api(true).get(
    `${ALM_URL}/${endPoints.ALM_USERS}/${id}/${endPoints.ALM_CALENDAR}`
  );
  const result = response;
  return result;
};
const getPostsComments = async (postId: any, offset: number) => {
  try {
    const extraParams = {
      params: {
        include: constants.CREATED_BY,
        'filter.state': constants.ACTIVE,
        'page[offset]': offset,
        'page[limit]': constants.LP_PAGE_LIMIT,
      },
    };
    const response = await Api(true).get(
      `${ALM_URL}/${endPoints.ALM_POSTS}/${postId}/${endPoints.ALM_COMMENTS}`,
      extraParams
    );
    return response;
  } catch (e) {
    return e;
  }
};
const createPostComment = async (postId: string, data: any) => {
  try {
    const response = await Api(true).post(
      `${ALM_URL}/${endPoints.ALM_POSTS}/${postId}/${endPoints.ALM_COMMENTS}`,
      data
    );
    return response;
  } catch (e) {
    return e;
  }
};
const getCommentsReplies = async (commentId: any, offset: number) => {
  try {
    const extraParams = {
      params: {
        include: constants.CREATED_BY,
        'filter.state': constants.ACTIVE,
        'page[offset]': offset,
        'page[limit]': constants.LP_PAGE_LIMIT,
      },
    };
    const response = await Api(true).get(
      `${ALM_URL}/${endPoints.ALM_COMMENTS}/${commentId}/${endPoints.ALM_REPLY}`,
      extraParams
    );
    return response;
  } catch (e) {
    return e;
  }
};
const replyToComment = async (commentId: string, data: any) => {
  try {
    const response = await Api(true).post(
      `${ALM_URL}/${endPoints.ALM_COMMENTS}/${commentId}/${endPoints.ALM_REPLY}`,
      data
    );
    return response;
  } catch (e) {
    return e;
  }
};

const addCommentVote = async (commentId: string, action: string) => {
  const response = await Api(true).post(
    `${ALM_URL}/${endPoints.ALM_COMMENTS}/${commentId}/${endPoints.ALM_COMMENT_VOTE}?action=${action}`
  );
  const result = response;
  return result;
};

const fetchAllVideos = async (id: any) => {
  const extraParams = {
    params: {
      'page[limit]': 100,
      'filter.loTypes': 'course',
      sort: 'name',
      'filter.catalogIds': `${id}`,
      'filter.ignoreHigherOrderLOEnrollment': true,
      'filter.ignoreEnhancedLP': true,
    },
  };
  const response = await Api(true).get(
    `${ALM_URL}/${endPoints.ALL_LEARNING_PROGRAMS}`,
    extraParams
  );
  const result = response;
  return result;
};
// ********************************
// const fetchContentByCatalogId=async(catId:any)=>{
//     const extraParams={
//         params:{
//             'page[limit]':100,
//             'filter.loTypes':"course",
//             'filter.catalogIds':catId,
//             'sort':"name",
//             'filter.ignoreEnhancedLP':false
//         }
//     }
//     console.log("catIdcatIdcatIdcatIdcatId",catId,extraParams)
//     const response=await Api(true).get(`${ALM_URL}/${endPoints.ALL_LEARNING_PROGRAMS}`,extraParams)
//     const result = response;
//     return result;
// }

//
const fetchAllEnrolled = async () => {
  const extraParams = {
    params: {
      'page[limit]': constants.LP_PAGE_LIMIT,
      'filter.loTypes': 'learningProgram',
      sort: 'dateEnrolled',
      completed: true,
      include: 'learningObject',
      includeHierarchicalEnrollments: false,
    },
  };
  const response = await Api(true).get(`${ALM_URL}/${endPoints.ALM_ENROLLMENTS}`, extraParams);
  const result = response;
  return result;
};
const deleteComment = async (commentId: string) => {
  const response = await Api(true).delete(`${ALM_URL}/${endPoints.ALM_COMMENTS}/${commentId}`);
  const result = response;
  return result;
};
const deleteVote = async (commentId: string, action: string) => {
  const response = await Api(true).delete(
    `${ALM_URL}/${endPoints.ALM_COMMENTS}/${commentId}/${endPoints.ALM_COMMENT_VOTE}?action=${action}`
  );
  const result = response;
  return result;
};
const myBookmarks = async () => {
  const extraParams = {
    params: {
      'page[limit]': 100,
      'filter.loTypes': 'course,learningProgram',
      'filter.bookmarks': true,
      sort: '-dateCreated',
      'filter.ignoreEnhancedLP': false,
    },
  };
  const response = await Api(true).get(
    `${ALM_URL}/${endPoints.ALL_LEARNING_PROGRAMS}`,
    extraParams
  );
  const result = response;
  return result;
};

const deleteReply = async (replyId: string) => {
  const response = await Api(true).delete(`${ALM_URL}/${endPoints.ALM_REPLY}/${replyId}`);
  const result = response;
  return result;
};

const getAllEnrolledStartedCompletedPrograms=async(catId:number,type:any)=>{
  const parms=[
      'enrollment.loResourceGrades',
      'enrollment.loInstance.loResources.resources',
      'subLOs.enrollment.loResourceGrades',
      'instances.loResources.resources',
      'skills.skillLevel.skill',
      'subLOs.instances.subLoInstances',
      'instances.badge',
      'subLOs.subLOs.enrollment',
      'subLOs.subLOs',
      'enrollment',
      'instances.badge'
  ];
  let includeParams=`?include=${parms.toString()}`;

  const extraParams={
      params:{
          'page[limit]':10,
          'filter.loTypes': type==="Achievements"?"learningProgram":"course",
          'filter.catalogIds':catId,
          'sort':"name",
          'filter.ignoreHigherOrderLOEnrollment':true,
          'filter.ignoreEnhancedLP':false,       
          'filter.learnerState':'enrolled,completed,started'   
      }
  }
  const response=await Api(true).get(`${ALM_URL}/${endPoints.ALL_LEARNING_PROGRAMS}/${includeParams}`,extraParams)
  const result = response;
  return result;
}

const addAlmNotes = async (id: any, payload: any) => {
  const response = await Api(true).post(`${ALM_URL}${endPoints.ADD_ALM_NOTES(id)}`, payload);
  const result = response;
  return result;
};

const nextBaseUrl = async (url: string) => {
  const response = await Api(true).get(url);
  const result = response;
  return result;
};

const getRepliesBasedOnCommentId = async (id: any) => {
  const extraParams = {
    params: {
      'page[limit]': 10,
      'page[offset]': 0,
      sort: '-dateUpdated',
    },
  };
  const response = await Api(true).get(
    `${ALM_URL}${endPoints.GET_ALM_REPLIES_NOTES(id)}`,
    extraParams
  );
  const result = response;
  return result;
};
const updateUserContent = async (userId: any, contentLocale: any) => {
  const response = await Api(true, { 'Accept-Language': contentLocale }).patch(`${ALM_URL}/users/${userId}`, {
    data: {
      id: userId,
      type: 'user',
      attributes: {
        contentLocale: contentLocale,
        uiLocale: contentLocale,
      },
    },
  });
  const result = response;
  return result;
};

const updateUserEmail = async (userId: any, email: any) => {
  const response = await Api(true).patch(`${ALM_URL}/users/${userId}`, {
    data: {
      id: userId,
      type: 'user',
      attributes: {
        email: email,
      },
    },
  });
  const result = response;
  return result;
};
const getloResourceGrades = async (loResourceGradesId: any) => {
  //loResourceGrades/course
  const response = await Api(true).get(
    `${ALM_URL}${endPoints.GET_LO_RESOURCE_GRADE(loResourceGradesId)}`
  );
  const result = response;
  return result;
};

const getUserNotification = async (
  cursor: number,
  userId: string,
  limit: number = constants.LP_PAGE_LIMIT,
  userLanguage: string
) => {
  try {
    let url = `${ALM_URL}/users/${userId}/userNotifications?page[limit]=${limit}`;
    if (cursor) {
      url = url + `&page[cursor]=${cursor}`;
    }
    const extraParams: any = {
      params: {
        announcementsOnly: false,
        language: userLanguage,
        userSelectedChannels: notificationSettingsSelected.join(",")
      },
    };
    const response = await Api(true).get(url, extraParams);
    const result = response;
    return result;
  } catch (error) {
    console.log(error);
  }
};
const patchUserNotifications = async (userId: any, body: any) => {
  body.attributes.actionTaken = true;
  body.attributes.read = true;
  try {
    await Api(true, {'Content-Type': 'application/vnd.api+json;charset=UTF-8'}).patch(
      `${ALM_URL}/users/${userId}/userNotifications/${body.id}`,
      {
        data: body,
      }
    );
  } catch (error) {
    console.log(error);
  }
};
const getUserSettings = async () => {
  const response = await Api(true).get(`${ALM_URL}${endPoints.ALM_USER_SETTING}`);
  const result = response;
  return result;
};
const postUserSettings = async (obj: any) => {
  const body = {
    data: {
      id: obj.id,
      type: 'userSetting',
      attributes: {
        type: 'dnd',
        dndSetting: {
          blockDirectEmail: obj.flag,
          blockDirectReportsEmail: obj.flag,
          blockEscalationEmailToMgr: obj.flag,
          blockSkipLevelReportsEmail: obj.flag,
        },
      },
    },
  };
  const response = await Api(true).patch(`${ALM_URL}${endPoints.ALM_USER_SETTING}`, body);
  const result = response;
  return result;
};
const getLiveMeating = async (id: string) => {
  const response = await Api(true).get(`${ALM_URL}${endPoints.ALM_USERS_CALENDAR(id)}`);
  const result = response;
  return result;
};

export const getBadgeList=async ()=>{
  const extraParams = {
      params: {
          'page[limit]': 100,
          'sort':'name',
      }
  }
  const response = await Api(true).get(`${ALM_URL}/${endPoints.ALM_BADGES}`,extraParams)
  const result = response;
  return result;
}

export const getBadgesByuserId=async (id:number)=>{
  const extraParams = {
      params: {
          'page[limit]': 100,
          'sort':'dateAchieved'
      }
  }
  const response = await Api(true).get(`${ALM_URL}/${endPoints.USERS}/${id}/userBadges`,extraParams)
  const result = response;
  return result;
}

const getRecomendedContent=async(data:any)=>{
  let isData=[]
  if(data){

    isData =data?.join(',')
  }
  const extraParams = {
      params: {
          'page[limit]': 10,
          'filter.loTypes': 'course',
          'page[offset]': 0,
          "sort":"name",
          "ids": isData,
          'filter.ignoreEnhancedLP': true
      }
  }
  const response = await Api(true).get(`${ALM_URL}/${endPoints.ALL_LEARNING_PROGRAMS}`,extraParams)
  const result = response;
  return result;
}




export const apis = {
  getLiveMeating,
  getUserSettings,
  postUserSettings,
  getloResourceGrades,
  deleteReply,
  deleteVote,
  deleteComment,
  addCommentVote,
  checkAlmUser,
  getUploadInfo,
  myBookmarks,
  uploadImage,
  getLearningProgram,
  getFundamentalProgram,
  getFundamentalProgramList,
  getBadges,
  getEnrollments,
  getBookmark,
  userEnroll,
  getProgramList,
  getProgramDetail,
  getProgramDetailByCourseId,
  getRelatedContent,
  getPost,
  fetchAllEnrolled,
  fetchCatalogs,
  fetchContentByCatalogId,
  unEnrollProgram,
  addBookMarkLearningObjects,
  deleteBookMarkLearningObjects,
  fetchNewVideos,
  fetchAllVideos,
  getCalender,
  getPostsComments,
  replyToComment,
  createPostComment,
  getCommentsReplies,
  getAllEnrolledStartedCompletedPrograms,
  addAlmNotes,
  getRepliesBasedOnCommentId,
  nextBaseUrl,
  fetchContentByCatalogIdForLibrary,
  getUserNotification,
  updateUserContent,
  // getUserNotification,
  updateUserEmail,
  getCourseDetail,
  patchUserNotifications,
  getBadgeList,
  getBadgesByuserId,
  getRecomendedContent
};
